import { Injectable } from '@angular/core';
import { MenuItem } from '../models/sidebar';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  menuItems: MenuItem[] = [];

  constructor() {
    this.loadMenuItems();
  }

  private loadMenuItems() {
    this.menuItems = [];

    const flags: { [key: string]: boolean } = {
      agrinio: environment.agrinio,
      people: environment.people,
      structural: environment.structural,
      traffic: environment.traffic,
      mediaServer: environment.mediaServer,
      flexi: environment.flexi,
      aigaleo: environment.aigaleo,
      fleet: environment.fleet,
    };

    const activeFlags = Object.keys(flags).filter(flag => flags[flag]);

    if (activeFlags.length === 0) {
      this.menuItems.push({
        icon: 'dashboard',
        label: 'SIDEBAR.HOME',
        route: 'home',
        submenu: [],
        showSubmenu: false
      });

      this.menuItems.push({
        icon: 'settings',
        label: 'SIDEBAR.MANAGEMENT',
        route: 'management',
        submenu: [
          {
            icon: 'device_hub',
            label: 'SIDEBAR.DEVICES',
            route: 'management/devices',
            submenu: [],
            showSubmenu: false
          }
        ],
        showSubmenu: false
      });

      this.menuItems.push({
        icon: 'business',
        label: 'SIDEBAR.STATIONS',
        route: 'stations',
        submenu: [
          {
            icon: 'people',
            label: 'SIDEBAR.PEOPLE',
            route: 'stations/people',
            submenu: [],
            showSubmenu: false
          }
        ],
        showSubmenu: false
      });

      this.menuItems.push({
        icon: 'location_city',
        label: 'SIDEBAR.INFRASTRUCTURE',
        route: 'infrastructure',
        submenu: [
          {
            icon: 'engineering',
            label: 'SIDEBAR.STRUCTURAL_HEALTH',
            route: 'infrastructure/structural-health',
            submenu: [
              {
                icon: 'assessment',
                label: 'SIDEBAR.RECORDS',
                route: 'infrastructure/structural-health/records',
                submenu: [],
                showSubmenu: false
              },
            ],
            showSubmenu: false
          },
          {
            icon: 'construction',
            label: 'SIDEBAR.TRAFFIC_MONITORING',
            route: 'infrastructure/traffic-monitoring',
            submenu: [],
            showSubmenu: false
          }
        ],
        showSubmenu: false
      });

    } else {
      if (
        !(activeFlags.length === 1 && activeFlags[0] === 'fleet') &&
        !(activeFlags.length === 1 && activeFlags[0] === 'agrinio') &&
        !(activeFlags.length === 1 && activeFlags[0] === 'mediaServer') &&
        !(activeFlags.length === 1 && activeFlags[0] === 'flexi') &&
        !(activeFlags.length === 1 && activeFlags[0] === 'aigaleo')
      ) {

        this.menuItems.push({
          icon: 'dashboard',
          label: 'SIDEBAR.HOME',
          route: 'home',
          submenu: [],
          showSubmenu: false
        });
      }
      if (environment.people || environment.structural || environment.traffic) {
        const managementSubmenu: MenuItem[] = [
          {
            icon: 'device_hub',
            label: 'SIDEBAR.DEVICES',
            route: 'management/devices',
            submenu: [],
            showSubmenu: false
          }
        ];
        this.menuItems.push({
          icon: 'settings',
          label: 'SIDEBAR.MANAGEMENT',
          route: 'management',
          submenu: managementSubmenu,
          showSubmenu: false
        });
      }

      if (environment.people) {
        const stationsSubmenu: MenuItem[] = [
          {
            icon: 'people',
            label: 'SIDEBAR.PEOPLE',
            route: 'stations/people',
            submenu: [],
            showSubmenu: false
          }
        ];
        this.menuItems.push({
          icon: 'business',
          label: 'SIDEBAR.STATIONS',
          route: 'stations',
          submenu: stationsSubmenu,
          showSubmenu: false
        });
      }

      if (environment.structural || environment.traffic) {
        const infrastructureSubmenu: MenuItem[] = [];
        if (environment.structural) {
          infrastructureSubmenu.push({
            icon: 'engineering',
            label: 'SIDEBAR.STRUCTURAL_HEALTH',
            route: 'infrastructure/structural-health',
            submenu: [
              {
                icon: 'assessment',
                label: 'SIDEBAR.RECORDS',
                route: 'infrastructure/structural-health/records',
                submenu: [],
                showSubmenu: false
              },
            ],
            showSubmenu: false
          });
        }
        if (environment.traffic) {
          infrastructureSubmenu.push({
            icon: 'construction',
            label: 'SIDEBAR.TRAFFIC_MONITORING',
            route: 'infrastructure/traffic-monitoring',
            submenu: [],
            showSubmenu: false
          });
        }
        this.menuItems.push({
          icon: 'location_city',
          label: 'SIDEBAR.INFRASTRUCTURE',
          route: 'infrastructure',
          submenu: infrastructureSubmenu,
          showSubmenu: false
        });
      }

      if (environment.agrinio) {
        this.menuItems.push({
          icon: 'assignment',
          label: 'SIDEBAR.ACCESS_CONTROL',
          route: 'access-control',
          submenu: [
            {
              icon: 'person_add',
              label: 'SIDEBAR.USERS_WHITELIST',
              route: 'access-control/whitelist',
              submenu: [],
              showSubmenu: false
            },
            {
              icon: 'lock',
              label: 'SIDEBAR.ACCESS_MANAGEMENT',
              route: 'access-control/management',
              submenu: [],
              showSubmenu: false
            },
          ],
          showSubmenu: false
        });
      }

      if (environment.mediaServer) {
        this.menuItems.push({
          icon: 'videocam',
          label: 'SIDEBAR.MEDIA_SERVER',
          route: 'media-server',
          submenu: [],
          showSubmenu: false
        });
      }

      if (environment.flexi) {
        this.menuItems.push({
          icon: 'widgets',
          label: 'SIDEBAR.FLEXI_CROSS',
          route: 'flexi',
          submenu: [
            {
              icon: 'notifications',
              label: 'SIDEBAR.ALERTS',
              route: 'flexi/alerts',
              submenu: [],
              showSubmenu: false
            }
          ],
          showSubmenu: false
        });
      }

      if (environment.aigaleo) {
        this.menuItems.push({
          icon: 'directions_car',
          label: 'SIDEBAR.AIGALEO',
          route: 'aigaleo',
          submenu: [],
          showSubmenu: false
        });
      }

      if (environment.fleet) {
        this.menuItems.push({
          icon: 'my_location',
          label: 'Fleet',
          route: 'fleet',
          submenu: [
            {
              icon: 'manage_accounts',
              label: 'Management',
              route: 'fleet/management',
              submenu: [],
              showSubmenu: false
            },
            {
              icon: 'report_problem',
              label: 'Alerts',
              route: 'fleet/alerts',
              submenu: [],
              showSubmenu: false
            },
            {
              icon: 'schedule',
              label: 'Schedule',
              route: 'fleet/schedule',
              submenu: [],
              showSubmenu: false
            },
            {
              icon: 'build',
              label: 'Repairs',
              route: 'fleet/repairs',
              submenu: [],
              showSubmenu: false
            },
            {
              icon: 'people',
              label: 'Citizen Requests',
              route: 'fleet/citizen-requests',
              submenu: [],
              showSubmenu: false
            },
          ],
          showSubmenu: false
        });
      }
    }
  }

  getMenuItems(): MenuItem[] {
    return this.menuItems;
  }
}